export default "__VITE_ASSET__g0_vSaUW__"